
<template>
  <div class="full-window-layout">

    <div class="col device_state" >
      <div class="device_state_grid">

        <div class="text-div-1" @click="navigateToDevicesManage(0)">
          <div class="home-status">

            <div style="margin-bottom: 10px;color: yellow;font-size: 24px;">{{ deviceNumberStatistics.total }}</div>
            <div style="margin-bottom: 20px;">监测总数（台）</div>


          </div>
          <div class="home-line" style="margin-left: 10px;height: 78%;">
            <img src="../../assets/bigscreen/线条.png" style="height: 80%;">
          </div>
        </div>
        <div class="text-div-2" @click="navigateToDevicesManage(1)">
          <div class="home-status">
            <div style="margin-bottom: 10px;color: rgb(39, 213, 120);font-size: 24px;">{{deviceNumberStatistics.health}}</div>
            <div style="margin-bottom: 20px">正常运行（台）</div>
          </div>
          <div style="margin-left: 10px;height: 78%;">
            <img src="../../assets/bigscreen/线条.png" style="height: 90%;">
          </div>
        </div>
        <div class="text-div-3" @click="navigateToDevicesManage(2)">
          <div class="home-status">
            <div style="margin-bottom: 10px;color: rgb(255, 66, 58);font-size: 24px;">{{deviceNumberStatistics.fault}}</div>
            <div style="margin-bottom: 20px">报警设备（台）</div>
          </div>
          <div style="margin-left: 10px;height: 78%;">
            <img src="../../assets/bigscreen/线条.png" style="height: 90%;">
          </div>
        </div>
        <div class="text-div-4" @click="navigateToDevicesManage(3)">
          <div class="home-status">
            <div style="margin-bottom: 10px;color: rgb(71, 111, 187);font-size: 24px;">{{deviceNumberStatistics.stopped}}</div>
            <div style="margin-bottom: 20px">停机设备（台）</div>
          </div>
          <div style="margin-left: 10px;height: 78%;">
            <img src="../../assets/bigscreen/线条.png" style="height: 90%;">
          </div>
        </div>
        <div class="text-div-5" @click="navigateToDevicesManage(4)" >
          <div class="home-status">
            <div style="margin-bottom: 10px;color: rgb(163, 163, 163);font-size: 24px;">{{deviceNumberStatistics.offline}}</div>
            <div style="margin-bottom: 20px">离线设备（台）</div>
          </div>
        </div>
      </div>

    </div>

   
    <!-- 测点状态统计 -->
    <div class="col measurepoint-container" ref="sensorsStatusStatistics">
    
    </div>

    <!-- 故障案例统计 -->
    <div class="col fault-container" ref="alarmConfirmedStatistics"></div>

    <!-- 背景图 -->
    <!-- <div class="col bigpic-container" ref="rt_wp" id="rt_wp">
        <div class="bigpic-container-div">
          <div class="rtmarker" style="left: 50%; top: 50%;" title="设备A运行中">
            <img src='@/assets/bigscreen/2.png'  />
          </div>
          <div class="rtmarker" style="left: 0%; top: 0%;" title="设备A运行中">
            <img src='@/assets/bigscreen/2.png'  />
          </div>
          <div class="rtmarker" style="left: 100%; top: 0%;" title="设备A运行中">
            <img src='@/assets/bigscreen/2.png'  />
          </div>
          <div class="rtmarker" style="left: 0%; top: 100%;" title="设备A运行中">
            <img src='@/assets/bigscreen/2.png'  />
          </div>
          <div class="rtmarker" style="left: 100%; top: 100%;" title="设备A运行中">
            <img src='@/assets/bigscreen/2.png'  />
          </div>
        </div>
    </div> -->


    <div class="col bigpic-container">
      <div class="bigpic-container-div" ref="rt_wp" id="rt_wp">
        <!-- <div v-if="alarmPoint.length && userName !='nmyh'">
        
          <div v-for="(point, index) in alarmPoint" :key="index">
            <div class="rtmarker" :style="{ left: point.x, top: point.y }"
              v-if="keydevice.indexOf(point.device_name) ==-1"
              :title="'分厂：' + point.factory + '\n' + '厂房：' + point.plant_name + '\n' + '设备名：' + point.device_name + '\n' + point.alarm_info">
              <div class="image-rtmarker">
                <img src="@/assets/bigscreen/2.png" alt="Marker Image" @click="navigateToAlarmsManage(point.item)" />
              </div>
            </div>
             <div v-for="(value,key)  in devinfors1" :key="key" 
             >
              <div 
               :title="tooltip"
               @mouseover="showTooltip(point,value.nameshow)"
               @mouseout="hideTooltip"
               class="rtmarker"
               :style="{ left: value.leftX, top: value.topY,zIndex: point.device_name === value.nameshow ? 2 : 1}"
              > 
              <div class="image-rtmarker"  v-if="value.status != null" >
                <img v-if="value.status == 1" src="@/assets/bigscreen/1.png" alt="Marker Image"
                    @click="navigateToAlarmsManage(point.item,value.nameshow)" />
                  <img v-if="value.status == 2" src="@/assets/bigscreen/2.png" alt="Marker Image"
                    @click="navigateToAlarmsManage(point.item,value.nameshow)" />
                  <img v-if="value.status == 3" src="@/assets/bigscreen/3.png" alt="Marker Image"
                    @click="navigateToAlarmsManage(point.item,value.nameshow)" />
                  <img v-if="value.status == 4" src="@/assets/bigscreen/4.png" alt="Marker Image"
                    @click="navigateToAlarmsManage(point.item,value.nameshow)" />
              </div>
              <div class="import-Info" v-if="value.status != null" :style="{ left: value.leftX, top: value.topY }">
                <span>{{ value.nameshow.split('_')[0] }}</span>
              
                <span v-for="(item, index) in value.val" :key="index">
                  <span class="Info1"> {{ item.name }}：{{ item.intensity }} mm/s</span>
                </span>
                <span class="Info1">{{ value.current }}A，{{ value.temperature }}°C</span>
              </div>
             </div>
             </div>
        

          </div>
        </div> -->
        <div>
          <div class="rtmarker" v-for="(value,key, index) in devinfors1" :key="key"
            :style="{ left: value.leftX , top: value.topY}">
            <div class="image-rtmarker" v-if="value.status != null ">
              <img v-if="value.status ==1" src="@/assets/bigscreen/1.png" alt="Marker Image"
               />
               <img v-if="value.status == 2 && userName !='nmyh'" src="@/assets/bigscreen/2.png" alt="Marker Image"/>
               <img v-if="value.status == 2 && userName =='nmyh'" src="@/assets/bigscreen/1.png" alt="Marker Image"/>
              <img v-if="value.status ==3" src="@/assets/bigscreen/3.png" alt="Marker Image"
                />
              <img v-if="value.status ==4" src="@/assets/bigscreen/4.png" alt="Marker Image"
                />
            </div>
            <div class="import-Info" v-if="value.status !=null " :style="{ left: value.leftX , top: value.topY}">
              <span>{{ value.nameshow.split('_')[0] }}</span>
              
              <span v-for=" (item,index) in value.val " :key="index">
                <span class="Info1"> {{item.name}}：{{item.intensity}} mm/s</span>
              </span>
              <span class="Info1">{{value.current}}A，{{value.temperature}}°C</span>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!-- 设备状态统计 -->
    <div class="col deviecstate-container" ref="deviceNumberStatistics"></div>

    <!-- 各级告警统计 -->
    <div class="col statistics-container" ref="alarmMethodStatistics"></div>

    <!-- 告警类型统计 -->
    <div class="col alarmstype-container" ref="alarmTypeStatistics"></div>

    <!-- 告警列表统计 -->
    <div class="col alarmlist-container">
      <span class="table-title">告警列表</span>
      <div class="in_table" ref="rt_table"></div>


    </div>
    <!-- 报警趋势 -->
    <div class="col alarms-container" ref="alarmMonthlyStatisticsDate"></div>


    <faultInfo ref="faultInfoFlag" @handleInfo="handleInfo"></faultInfo>


  </div>

</template>

<script>

import * as echarts from 'echarts';

import Pagination from "@/components/Pagination";
import faultInfo from "@/components/fault/faultInfo";
import {devinfors} from '@/config/deviceImport'
import {apiDevice,apiAlarmslist,apiDeviceNumberStatistics} from '@/api/api';
import {
  apiAlarmMonthlyStatistics,
  apiAlarmConfirmedStatistics,
  apiAlarmTypeStatistics,
  apiAlarmMethodStatistics,
  apiSensorsStatusStatistics,
  apiSensorStatusVersion,
  apiSensorlist,
  apiSensorWithExtra
} from '@/api/api';

import deviceTypeConfig from "@/config"
import {useMutitabsStore} from "@/store/mutitabs";
import {getStorage,setStorage} from "@/utils/util";




export default {
  components:{
      Pagination,
      faultInfo,
     
  },
  emits: ['handleInfo'],
  setup(){
      const mutitabsstore = useMutitabsStore()
      return { mutitabsstore}
  },
  data() { 
    return {      
      count:0,
      points: [],
      tableData: [],
      devicestatusData:[],
      devinfors1:null,
      tooltip: null,
      userName:null,
      AlarmsParm:{
          page: 1,
          page_size: 10,
          level: null,
          ordering:"processed,-time",
          device_name: null,
          device_type:null,      
          time_after: null,   
          time_before: null         
      },
      keydevice:[
      '聚合釜卸料泵_PVCYZ277',
      '聚合釜卸料泵_PVCYZ278',
      '聚合釜卸料泵_PVCYZ279',
      'VCM加料泵_PVCYZ306',
      'VCM加料泵_PVCYZ307',
      '1#炉净气风机_DSYZ001',
      '8#炉净气风机_DSYZ206',
      '给水泵1_HCYZ001',
      '给水泵2_HCYZ002',
      '球罐单体泵A_HCYZ080',
      '球罐单体泵B_HCYZ081',
      '阳极液循环泵_SJYZ019',
      '阳极液循环泵_SJYZ020',
      '氢压机_SJYZ055',
      '氢压机_SJYZ085',
      '烧碱泵_SJYZ122',
      '烧碱泵_SJYZ123',
      '氢压机_GJYZ200',
      '氢压机_GJYZ201',
      '氢压机_GJYZ202',
      '压缩机_YQYZ001',
      '压缩机_YQYZ002',
      '压缩机_YQYZ003',
      '压缩机_YQYZ004',
      '压缩机_YQYZ005',
      '气烧窑3#主引风机_YLT01',
      ],
  
      saveSensorlist:[],
      
      DevicesMapParm:{
          page: 1,
          page_size: 200,
      },
      tableLineData:{
      },
  
      ws_manage:{
          isConnected: false,
          socket: null, 
          message: '', 
          receivedMessage: '',
          url:'',
          pingTimer: null,
          checktime: 0,
          webcloseflag: false,
      },
      intervalId:null,
    
      myCharts: {
        deviceNumberStatistics:null,  //设备状态
       
        alarmMonthlyStatistics:null,  //报警趋势
        alarmTypeStatistics:null,     //报警类型
        alarmMethodStatistics:null,   //各级报警
        alarmConfirmedStatistics:null, //故障案例
        sensorsStatusStatistics:null, //测点状态
      },
      
      //设备状态的数量
      deviceNumberStatisticsDefault:{
          total:0,
          health:0,
          offline:0,
          stopped:0,
          fault:0
      },
      deviceNumberStatistics:{},

      //报警趋势
      alarmMonthlyStatisticsDateDefault : [
        {month:"",processed:0,total:0},
        {month:"",processed:0,total:0},
        {month:"",processed:0,total:0},
        {month:"",processed:0,total:0},
        {month:"",processed:0,total:0},
        {month:"",processed:0,total:0}
      ],
      alarmMonthlyStatisticsDate:[],

      //故障案例统计折线图
      alarmConfirmedStatisticsDateDefault : {
         largeUnit : 0,      //大机组
         keyEquipment : 0    //重点设备
      },
      alarmConfirmedStatisticsDate:{},

      //报警类型统计
      alarmTypeStatisticsDateDefault:{
        vibrate:0,          //振动
        temperature:0,      //温度 
        current: 0          //电流
      },
      alarmTypeStatisticsDate:{},

      //各级报警统计
      alarmMethodStatisticsDataDefault:{
        intelligentAlarm : 0,       //智能报警    
        fixedHighReport : 0,        //固定高报  
        fixedHighHighReport : 0,    //固定高高报
        faultWarning : 0            //故障预警
      },
      alarmMethodStatisticsData:{},

      //测点状态统计
      sensorsStatusStatisticsDataDefault:{
         health:0,            //健康
         fault:0,             //故障
         stopped:0,           //停机
         offline:0            //离线
      },
      sensorsStatusStatisticsData:{},

      //分厂名称定义
      factoryName : [
          deviceTypeConfig.DEVICE_TYPE_1,
          deviceTypeConfig.DEVICE_TYPE_2,
          deviceTypeConfig.DEVICE_TYPE_3,
          deviceTypeConfig.DEVICE_TYPE_4,
          deviceTypeConfig.DEVICE_TYPE_5,
          deviceTypeConfig.DEVICE_TYPE_6
      ],

      //工厂原图大小
      factoryOriginMapWidth : 5760, //4000  
      factoryOriginMapHeight : 3240, //2140 

      //每个数组对应一个分厂，数组里元素个数就是厂房个数，另外多一个区域，放未知的，比如那种分厂名字输入错误，匹配不了的情况。
      factoryFloorCoordinatesInfo:[ 
        
        //分厂1：PVC分厂   厂房 ：14个 已完成
        [
          {x0:3991,y0:1089,x1:4117,y1:1161,name:["136聚合1楼"]},
          {x0:4110,y0:982,x1:4248,y1:1026,name:['136水泵房']},
          {x0:4138,y0:1050,x1:4262,y1:1123,name:['136单体框架1楼']},
          {x0:3900,y0:1031,x1:3979,y1:1090,name:['136汽提框架1楼']},
          {x0:4387,y0:1121,x1:4619,y1:1159,name:['循环水泵房']},
          {x0:4810,y0:1356,x1:4972,y1:1421,name:['10℃水泵房']},
          {x0:4781,y0:1269,x1:4941,y1:1334,name:['—35℃盐水泵']},
          {x0:4696,y0:1183,x1:4824,y1:1255,name:['0℃盐水泵']},
          {x0:4506,y0:1049,x1:4669,y1:1116,name:['凉水塔']},
          {x0:4259,y0:934,x1:4385,y1:995,name:['10万吨干燥3楼','10万吨干燥1楼']},
          {x0:4475,y0:889,x1:4607,y1:981,name:['12万吨干燥3楼','12万吨干燥1楼','12万吨母液泵房']},
          {x0:5049,y0:137,x1:5737,y1:1349,name:['未知']}],  
 
        //分厂2：电石分厂   厂房 ：26个  完成
        [
        {x0:651,y0:1552,x1:798,y1:1700,name:['1#电石炉净化五楼','1#电石炉净化一楼','新1号炉1楼']},
        {x0:820,y0:1538,x1:946,y1:1684,name:['新1、2号炉4楼','1#电石炉四楼']},
        {x0:960,y0:1569,x1:1064,y1:1764,name:['2#电石炉净化五楼','2#电石炉净化一楼','新2号炉1楼']},
        {x0:1073,y0:1591,x1:1187,y1:1692,name:['3#电石炉净化五楼','3#电石炉净化一楼','新3号炉1楼']},
        {x0:1203,y0:1555,x1:1323,y1:1647,name:['新3、4号炉4楼']},
        {x0:1348,y0:1588,x1:1456,y1:1716,name:['4#电石炉净化五楼','4#电石炉净化一楼','新4号炉1楼']},
        {x0:1621,y0:1573,x1:1749,y1:1703,name:['5#电石炉净化五楼','5#电石炉净化一楼','新5号炉1楼']},
        {x0:1780,y0:1567,x1:1901,y1:1607,name:['新5、6号炉4楼','']},
        {x0:1921,y0:1578,x1:2067,y1:1698,name:['6#电石炉净化五楼','6#电石炉净化一楼','新6号炉1楼']},
        {x0:2114,y0:1591,x1:2254,y1:1699,name:['7#电石炉净化五楼','7#电石炉净化一楼','新7号炉1楼']},
        {x0:2303,y0:1589,x1:2404,y1:1673,name:['新7、8号炉4楼','8#电石炉四楼']},
        {x0:2436,y0:1608,x1:2571,y1:1704,name:['8#电石炉净化五楼','8#电石炉净化一楼','新8号炉1楼']},
        {x0:1657,y0:1824,x1:1874,y1:1913,name:['新循环水泵房']},
        {x0:1983,y0:1041,x1:2066,y1:1141,name:['老循环水泵房']}, 
        {x0:2238,y0:1211,x1:2349,y1:1271,name:['2号炉三层半北面','1号净化1楼北侧','2号净化1楼北侧']},
        {x0:2242,y0:1315,x1:2352,y1:1382,name:['3号炉三层半北面','三号炉一楼']}, 
        {x0:2188,y0:1077,x1:2288,y1:1225,name:['老系统1#电石炉净化五楼','老系统1#电石炉净化一楼']},
        {x0:2118,y0:1144,x1:2223,y1:1211,name:['老系统2#电石炉净化五楼','老系统2#电石炉净化一楼','老系统3#电石炉净化五楼','老系统3#电石炉净化一楼']},
        {x0:2113,y0:1266,x1:2231,y1:1337,name:['配料站']},
        {x0:2099,y0:1006,x1:2213,y1:1069,name:['配料站1楼','碳材3#大厅','碳材大厅1楼干燥窑']},
        {x0:2215,y0:917,x1:2329,y1:996 ,name:['气烧窑2楼','气烧窑广场','气烧窑1楼','碳材大厅1楼','配料站5楼','气烧窑1#窑9米8']},
        {x0:1789,y0:864	,x1:1963,y1:953,name:['石头料场北','上料地坑','碳球厂房旁']},
        {x0:1659,y0:1717,x1:1866,y1:1809,name:['凉水塔顶层']},
        {x0:1828,y0:988	,x1:1969,y1:1091,name:['凉水塔顶层老电石']},
        {x0:1509,y0:1442,x1:1665,y1:1554,name:['配料站皮带机']},
        {x0:1468,y0:1572,x1:1598,y1:1707,name:['转运站']},
        {x0:177,y0:2297,x1:1961,y1:3037,name:['未知']}], 
        //分厂3：合成分厂   厂房 ：8个  已完成
        [
        {x0:2658,y0:1809,x1:2816,y1:1894,name:["净化厂房"]},
        {x0:3228,y0:1348,x1:3435,y1:1461,name:["二合一给水泵房"]},
        {x0:3417,y0:1513,x1:3557,y1:1613,name:["配水厂房"]},
        {x0:3479,y0:1359,x1:3613,y1:1473,name:["硫酸清净厂房"]},
        {x0:3271,y0:1863,x1:3439,y1:1950,name:["热水槽"]},
        {x0:3384,y0:1720,x1:3547,y1:1826,name:["化水厂房"]},
        {x0:2852,y0:1802,x1:2999,y1:1862,name:["精馏一楼"]},
        {x0:3948,y0:1389,x1:4090,y1:1496,name:["球罐泵房"]},
        {x0:2884,y0:1890,x1:3022,y1:1951,name:["VC压缩机"]},
        {x0:5049,y0:137,x1:5737,y1:1349,name:['未知']}],
      
        //分厂4：烧碱分厂   厂房 ：20个 未完成
        [
        {x0:4022,y0:1521,x1:	4209,y1:	1633,name:["二次盐水厂房","电解一楼",'脱氯一楼']},
        {x0:3845,y0:1518,x1:3984,y1:1613,name:["氯处理一楼循环泵","氯处理三楼","氯处理一楼氯水"]},
        {x0:2863,y0:1543,x1:3020,y1:1639,name:["氯处理一楼洗涤泵","脱氯一楼水泵","电解一楼"]},
        {x0:3864,y0:1638,x1:4008,y1:1714,name:["氢压机厂房"]},
        {x0:3621,y0:1720,x1:3792,y1:1850,name:["新循环水"]},
        {x0:3720,y0:1633,x1:3815,y1:1699,name:["新循环水风机"]},
        {x0:3566,y0:1528,x1:3712,y1:1611,name:["老循环水"]},
        {x0:3588,y0:1614,x1:3698,y1:1680,name:["老循环水风机"]},
        {x0:2687,y0:1612,x1:2783,y1:1664,name:["氢压机厂房氢压机"]},
        {x0:2838,y0:1647,x1:2976,y1:1712,name:["二次盐水厂房水泵"]},
        {x0:3678,y0:759,x1:3781,y1:809,name:["铁路西"]},
        {x0:3785,y0:876,x1:3877,y1:940,name:["一次盐水"]},
        {x0:2997,y0:924,x1:3142,y1:1016,name:["冷水机厂房"]},
        {x0:2852,y0:946,x1:2976	,y1:1014,name:["液氯厂房"]},
        {x0:2669,y0:852,x1:2804,y1:925,name:["新固碱一楼","新固碱二楼","新固碱三楼"]},
        {x0:2504,y0:788,x1:2644,y1:895,name:["蒸发一楼"]},
        {x0:2826,y0:851,x1:2948,y1:917,name:["老固碱二楼","老固碱一楼"]},
        {x0:3223,y0:953,x1:3432,y1:1061,name:["二次盐水厂房中间槽泵","地坑","氯处理一楼水泵","氯处理一楼鼓风机","氯处理一楼洗涤泵"]},
        {x0:3013,y0:1030,x1:3137,y1:1096,name:["氯压机厂房压缩机"]},
        {x0:2850,y0:1030,x1:2998,y1:1094,name:["氢压机厂房6万吨"]},
        {x0:2137,y0:2277,x1:3701,y1:2981,name:['未知']}],
        //分厂5：乙炔分厂   厂房 ：6个 完成
        [
        {x0:1660,y0:1147,x1:1834,y1:1236,name:["压缩厂房"]},
        {x0:1713,y0:1311,x1:1847,y1:1418,name:["破碎厂房南面",'南灰仓南面']},
        {x0:1446,y0:1308,x1:1576,y1:1398,name:["破碎厂房北面",'北灰仓处']},
        {x0:1977,y0:879,x1:2076 ,y1:1021,name:["乙炔循环水泵厂房"]},
        {x0:4205,y0:2201,x1:5693,y1:2861,name:["未知"]}],
        
        //分厂6：原料分厂   厂房 ：12个 完成
        [
        {x0:1063,y0:1308,x1:1201,y1:1413,name:["风机房"]},
        {x0:1046,y0:1207,x1:1171,y1:1294,name:["导热油平台"]},
        {x0:848,y0:1290,x1:1022,y1:1404,name:["中间仓"]},
        {x0:851,y0:1150,x1:1022,y1:1252,name:["上料斜桥"]},
        {x0:1186,y0:1434,x1:1313,y1:1508,name:["配料站5楼"]},
        {x0:1298,y0:1173,x1:1473,y1:1270,name:["炭材料场地坑"]},
        {x0:1234,y0:1276,x1:1356,y1:1350,name:["窑本体","窑尾","竖窑",'竖窑区域','地坑']},
        {x0:1237,y0:1364,x1:1381,y1:1412,name:["三筒窑"]},
        {x0:1334,y0:1427,x1:1458,y1:1494,name:['配料站']},
        {x0:1201,y0:732,x1:1293,y1:807,name:['窑体','大除尘北侧']},
        {x0:1310,y0:741,x1:1445,y1:862,name:['成品一楼','成品楼']},
        {x0:1459,y0:740,x1:1649,y1:836,name:['原煤仓','风机房三楼','煤粉车间']},
        {x0:1064,y0:731,x1:1185,y1:875,name:['风机房循环水泵']},
        {x0:4205,y0:2201,x1:5693,y1:2861,name:["未知"]}]
    ],

      //报警数据
      allDeviceAlarmInfo:{ 
        device: [] ,
        alarm : [] 
      },
      //报警点
      alarmPoint:[],
     

     
      //每个区域点
      alarmPointRegion:[[],[],[],[],[],[]],
      //每个分厂下的设备
      branchFactory:[[],[],[],[],[],[]],
      

    };
  },
  mounted() {
    //增加websocket的连接
    // this.creatWebSocket()  
   
    var value = getStorage("alarmPoint")
 
    this.userName = getStorage("userName")
    this.getDeivceSensorlist()
    this.alarmPoint = JSON.parse(value);
    if(this.alarmPoint == null)
      this.alarmPoint = [];

   
    this.$nextTick(() => {
      this.UpdateBigScreenData();
    
      this.initResize();
  

     
    });    
    
    // 定时器获取数据

  this.intervalId = setInterval(async () => {
    try {
      const res = await apiSensorStatusVersion()
      if(res.code = 200){
        if(res.data.data.time != getStorage('upTime')){
          setStorage('upTime',res.data.data.time)
           this.getDeivceSensorlist()
           this.UpdateBigScreenData();
        }
      }
      const currentTime = new Date().getTime()
      const lastDeviceSensorlistTime = Date.parse(getStorage('upTime'))
      console.log(currentTime - lastDeviceSensorlistTime)
      if(currentTime - lastDeviceSensorlistTime>=7200000 && currentTime-Date.parse(getStorage('upTime2')))
      {
        setStorage('upTime2',currentTime)                                    
        this.getDeivceSensorlist();
      }
    } catch (error) {
      console.error('定时器1开启错误:',error);
    }
  }, 300000); // 每5min秒请求一次

 
  },

  beforeUnmount() {
    //增加websocket的销毁
    // this.ws_manage.webcloseflag = true;
    // this.disconnectWebSocket()

    //销毁定时器
    clearInterval(this.intervalId);
    // clearInterval(this.intervalId2);
  },
  methods: {
    showTooltip(point,val) {
      // 根据条件设置 tooltip 的值
       
        if(point.device_name ==val){
        
          this.tooltip = '分厂：' + point.factory + '\n' + '厂房：' + point.plant_name + '\n' + '设备名：' + point.device_name + '\n' + point.alarm_info;
        }else{
          this.tooltip = null
        }
       
    },
    hideTooltip() {
      // 鼠标移出时清空 tooltip
      this.tooltip = null;
    },

   
     
    async  getDeivceSensorlist(){
      try{

      this.devinfors1 = null
      let devinforstemp = JSON.parse(JSON.stringify(devinfors))
      this.devinfors1 = devinforstemp
      let parm = {
            is_rtm: 1,  
            }
      const res = await apiSensorlist(parm);
      const res1 = await apiSensorWithExtra(parm)
      
        if (res1.data.code == 200 && res.data.code == 200) {
          for (let i = 0; i < res.data.data.total; i++) {
            let temperatureMax = res.data.data.items[0].temperature
            Object.values(this.devinfors1).forEach(value => {

              if (res.data.data.items[i].device_name == value.nameshow) {

                if (res.data.data.items[i].temperature > temperatureMax) {
                  temperatureMax = res.data.data.items[i].temperature
                }

                // 得到设备的状态
                value.status = res1.data.data.items[i].device_status
                // 得到设备的电流的值
                if (value.status == 4) {

                  value.current = 0
                  value.temperature =0

                }
                else {
                  value.current = res.data.data.items[i].type == 2 ? res.data.data.items[i].intensity : 0
                  value.temperature = temperatureMax
                }
                // 温振传感器的温度最大值
                value.nameshow = res1.data.data.items[i].device_name
             
                // let currentValue  = parseFloat(value.leftX)
                // currentValue += 0.5;
                // value.leftX = currentValue +"%"
                if (res.data.data.items[i].type == 1) {
                  value.val.push(
                    {
                      name: res.data.data.items[i].name,
                      intensity: value.status == 3 ? 0 : res.data.data.items[i].intensity,
                    })
                }




              }

              else {

                for (let n = 1; n < (value.name).length; n++) {

                  if (res1.data.data.items[i].device_status == 2 && res.data.data.items[i].device_name == value.name[n]) {
                    if (value.status == 2) {
                      break
                    }
                    if (value.status != 2) {
                      value.val = []
                    }
                    if (value.nameshow != res.data.data.items[i].device_name) {
                      if (res.data.data.items[i].temperature > temperatureMax) {
                        temperatureMax = res.data.data.items[i].temperature
                      }
                      // 得到设备的状态
                      value.status = res1.data.data.items[i].device_status
                      value.nameshow = res1.data.data.items[i].device_name
                      // 得到设备的电流的值
                      if (value.status == 4) {

                        value.current = 0
                        value.temperature =0

                      }
                      else {
                        value.current = res.data.data.items[i].type == 2 ? res.data.data.items[i].intensity : 0
                        value.temperature = temperatureMax
                      }

                      // 温振传感器的温度最大值
                     
                      // let currentValue  = parseFloat(value.leftX)
                      // currentValue += 0.5;
                      // value.leftX = currentValue +"%"
                      if (res.data.data.items[i].type == 1) {

                        value.val.push(
                          {
                            name: res.data.data.items[i].name,
                            intensity: value.status == 3 ? 0 : res.data.data.items[i].intensity,
                          })
                      }

                    }

                    break
                  }



                  if (res1.data.data.items[i].device_status == 1 && res.data.data.items[i].device_name == value.name[n]) {
                    if (value.status == 2 || value.status == 1) {
                      break
                    }



                    if (value.nameshow != res.data.data.items[i].device_name) {
                      if (value.status != 1) {
                        value.val = []
                      }

                      if (res.data.data.items[i].temperature > temperatureMax) {
                        temperatureMax = res.data.data.items[i].temperature
                      }
                      // 得到设备的状态
                      value.status = res1.data.data.items[i].device_status
                      // 得到设备的电流的值
                      if (value.status == 4) {

                        value.current = 0
                        value.temperature =0

                      }
                      else {
                        value.current = res.data.data.items[i].type == 2 ? res.data.data.items[i].intensity : 0
                        value.temperature = temperatureMax
                      }
                      // 温振传感器的温度最大值
                      value.nameshow = res1.data.data.items[i].device_name
                    


                      if (res.data.data.items[i].type == 1) {

                        value.val.push(
                          {

                            name: res.data.data.items[i].name,
                            intensity: value.status == 3 ? 0 : res.data.data.items[i].intensity,
                          })
                      }



                    }

                    break
                  }
                }
}
})
              
              
            
            }
        console.log('重点设备获取到的信息', this.devinfors1)
      } 
     

      } catch(error){
         console.log(error)
      }
     
    },

    //获取设备状态
    getDeviceNumberStatistics(){
      apiDeviceNumberStatistics().then(res => {
          if(res.data.code ==200) {
              this.deviceNumberStatistics = res.data.data
              this.initDeviceNumberStatisticsChart(this.deviceNumberStatistics)
          }else{
            this.initDeviceNumberStatisticsChart(this.deviceNumberStatisticsDefault)
          }
          }).catch(error => {  
              this.initDeviceNumberStatisticsChart(this.deviceNumberStatisticsDefault)
              if(error.msg)
                  this.$message.warning(`获取设备状态的数量失败 : ${error.msg}`);  
              else if(error.message)
                  this.$message.warning(`获取设备状态的数量失败 : ${error.message}`);  
              else 
                  this.$message.warning(`获取设备状态的数量失败`); 
      });
    },

    //获取报警趋势
    getAlarmMonthlyStatistics(){
      const currentDate = new Date();
      var month_before =  `${currentDate.getFullYear()}-${String(currentDate.getMonth()+1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`; 
      const diffTime = 5 * 30.5 * 24 * 3600 * 1000;
      const fiveMonthsAgoDate = new Date(currentDate.getTime() - diffTime);
      var month_after =  `${fiveMonthsAgoDate.getFullYear()}-${String(fiveMonthsAgoDate.getMonth()+1).padStart(2, '0')}-01`; 
      var pars = {
        month_after : month_after,
        month_before : month_before
      }
      apiAlarmMonthlyStatistics(pars).then(res => {
          if(res.data.code ==200) {
              this.alarmMonthlyStatisticsDate = res.data.data.items
              this.initAlarmMonthlyStatisticsChart(this.alarmMonthlyStatisticsDate);
          }else{
              this.initAlarmMonthlyStatisticsChart(this.alarmMonthlyStatisticsDateDefault);
          }
          }).catch(error => {  
              this.initAlarmMonthlyStatisticsChart(this.alarmMonthlyStatisticsDateDefault);
              if(error.msg)
                  this.$message.warning(`获取报警趋势失败 : ${error.msg}`);  
              else if(error.message)
                  this.$message.warning(`获取报警趋势失败 : ${error.message}`);  
              else 
                  this.$message.warning(`获取报警趋势失败`); 
      });
    },

    //获取故障案例统计   
    getAlarmConfirmedStatistics(){
      apiAlarmConfirmedStatistics().then(res => {
          if(res.data.code ==200) {
              var items = res.data.data.items
              for(var i=0;i<items.length;i++){
                if(items[i].device_group_type == 1){
                  this.alarmConfirmedStatisticsDate.keyEquipment = items[i].count
                  continue;
                }
                if(items[i].device_group_type == 2){
                  this.alarmConfirmedStatisticsDate.largeUnit = items[i].count
                }
              }
              this.initAlarmConfirmedStatisticsChart(this.alarmConfirmedStatisticsDate)
          }else{
            this.initAlarmConfirmedStatisticsChart(this.alarmConfirmedStatisticsDateDefault)
          }
          }).catch(error => {  
            this.initAlarmConfirmedStatisticsChart(this.alarmConfirmedStatisticsDateDefault)
              if(error.msg)
                  this.$message.warning(`获取故障案例统计失败 : ${error.msg}`);  
              else if(error.message)
                  this.$message.warning(`获取故障案例统计失败 : ${error.message}`);  
              else 
                  this.$message.warning(`获取故障案例统计失败`); 
      });
    },

    //报警类型统计
    getAlarmTypeStatistics(){
      apiAlarmTypeStatistics().then(res => {
          if(res.data.code ==200) {
              var items = res.data.data.items
              for(var i=0;i<items.length;i++){
                if(items[i].type_class == 1){
                  this.alarmTypeStatisticsDate.vibrate = items[i].count
                  continue;
                }
                if(items[i].type_class == 2){
                  this.alarmTypeStatisticsDate.current = items[i].count
                  continue;
                }
                if(items[i].type_class == 3){
                  this.alarmTypeStatisticsDate.temperature = items[i].count
                }
              }
              this.initAlarmTypeStatisticsChart(this.alarmTypeStatisticsDate)
          }else{
            this.initAlarmTypeStatisticsChart(this.alarmTypeStatisticsDateDefault)
          }
          }).catch(error => {  
            this.initAlarmTypeStatisticsChart(this.alarmTypeStatisticsDateDefault)
              if(error.msg)
                  this.$message.warning(`获取报警类型统计失败 : ${error.msg}`);  
              else if(error.message)
                  this.$message.warning(`获取报警类型统计失败 : ${error.message}`);  
              else 
                  this.$message.warning(`获取报警类型统计失败`); 
      });
    },

    //各级报警统计
    getAlarmMethodStatistics(data){
      apiAlarmMethodStatistics().then(res => {
          if(res.data.code ==200) {
            var items = res.data.data.items
              for(var i=0;i<items.length;i++){
                if(items[i].method == 1){
                  this.alarmMethodStatisticsData.intelligentAlarm  = items[i].count
                  continue;
                }
                if(items[i].method == 2){
                  this.alarmMethodStatisticsData.fixedHighReport  = items[i].count
                  continue;
                }
                if(items[i].method == 3){
                  this.alarmMethodStatisticsData.fixedHighHighReport  = items[i].count
                  continue;
                }
                if(items[i].method == 4){
                  this.alarmMethodStatisticsData.faultWarning   = items[i].count
                }
              }
              this.initAlarmMethodStatisticsChart(this.alarmMethodStatisticsData)
          }else{
              this.initAlarmMethodStatisticsChart(this.alarmMethodStatisticsDataDefault)
          }
          }).catch(error => {  
              this.initAlarmMethodStatisticsChart(this.alarmMethodStatisticsDataDefault)
              if(error.msg)
                  this.$message.warning(`获取各级报警统计失败 : ${error.msg}`);  
              else if(error.message)
                  this.$message.warning(`获取各级报警统计失败 : ${error.message}`);  
              else 
                  this.$message.warning(`获取各级报警统计失败`); 
      });
    },    
    
    //测点状态统计
    getSensorsStatusStatistics(){
      apiSensorsStatusStatistics().then(res => {
          if(res.data.code ==200) {
            var items = res.data.data.items
            console.log("传感器的状态",items)
            for(var i=0;i<items.length;i++){
              if(items[i].status == 1){
                this.sensorsStatusStatisticsData.health  = items[i].count
                continue;
              }
              if(items[i].status == 2){
                 if(this.userName =="nmyh"){
                   this.sensorsStatusStatisticsData.health += items[i].count
                  this.sensorsStatusStatisticsData.fault  = 0
                 
                }
                 else{
                  this.sensorsStatusStatisticsData.fault  = items[i].count
                 }
                continue;
              }
              if(items[i].status == 3){
                this.sensorsStatusStatisticsData.stopped  = items[i].count
                continue;
              }
              if(items[i].status == 4){
                this.sensorsStatusStatisticsData.offline   = items[i].count
              }
            }
            console.log('sensorsStatusStatisticsDataDefault :',this.sensorsStatusStatisticsDataDefault)
            this.initSensorsStatusStatisticsChart(this.sensorsStatusStatisticsData);
          }else{
              this.initSensorsStatusStatisticsChart(this.sensorsStatusStatisticsDataDefault);
          }
          }).catch(error => {  
              this.initSensorsStatusStatisticsChart(this.sensorsStatusStatisticsDataDefault);
              if(error.msg)
                  this.$message.warning(`获取测点状态统计失败 : ${error.msg}`);  
              else if(error.message)
                  this.$message.warning(`获取测点状态统计失败 : ${error.message}`);  
              else 
                  this.$message.warning(`获取测点状态统计失败`); 
      });
      
    }, 


    //报警趋势的折线图
    initAlarmMonthlyStatisticsChart(data){
      var alarmMonthlyStatisticsDateRef = this.$refs.alarmMonthlyStatisticsDate;
      var alarmMonthlyStatisticsDate = echarts.init(alarmMonthlyStatisticsDateRef);
      var alarmMonthlyStatisticsDateOption = {
        legend: {
          itemWidth: 12, 
          itemHeight: 12, 
          // 设置图例文字样式
          textStyle: {
            fontSize: 10, // 调整图例文字大小
            color: '#fff' 
          },
          top:'25%',
          right: '0%'
        },
        tooltip: {},
        grid: {  
				  left: '0%',  
				  right: '0%', 
				  top: '40%',   
				  bottom: '0%', 
				  containLabel: true 
				},

        title: {
          text: '报警趋势',
          //left: 'center'
          left: '6%',
          top: '12%',
          textStyle: {
              fontSize: 13,
              color: '#fff'
          }
        },
        dataset: {
          dimensions: ['product', 'processed', 'total'],
          source: [
            { product: data[0].month, 'processed': data[0].processed, 'total': data[0].total },
            { product: data[1].month, 'processed': data[1].processed, 'total': data[1].total },
            { product: data[2].month, 'processed': data[2].processed, 'total': data[2].total },
            { product: data[3].month, 'processed': data[3].processed, 'total': data[3].total, },
            { product: data[4].month, 'processed': data[4].processed, 'total': data[4].total, },
            { product: data[5].month, 'processed': data[5].processed, 'total': data[5].total, }
          ]
        },
        xAxis: { 
          type: 'category', 
          axisLabel: {
            show: true,
            fontSize: 10,
            //margin: 10, 
            color: '#DDDDDD'
          },},
        yAxis: {
            show: true,
            // name:"",
            // nameTextStyle: {  
            //     // color: '#fFFFFF',
            //     // padding: [0, 0, 0, 120],
            //     // fontSize: 15,
			      // },
            // position: 'left',
            type: 'value',
            axisLine: {
                show: true,
            },
            axisTick: {  
                show: true,
            },
            axisLabel: { 
                color: '#DDDDDD',
            },
            splitArea: {
                show: true,
                areaStyle: {
                    shadowBlur: 0,
                    shadowOffsetX:0,
                    shadowOffsetY:0,
                    opacity:0
                }
            },
            splitLine: {
                show:true, 
                lineStyle: {
                    type: "dotted",
                    width: 1,
                    color: 'rgba(100, 100, 100, 1.0)', 
                    dashOffset: 10 ,
                }
            }
        },
        series: [
          {
            type: 'bar',
            name: '报警处理',
            itemStyle: {
              color: 'green'
            }
          },
          {
            type: 'bar',
            name: '总报警数',
            itemStyle: {
              color: 'red'
            }
          }
        ]
      };
      
      alarmMonthlyStatisticsDate.setOption(alarmMonthlyStatisticsDateOption);
      this.myCharts.alarmMonthlyStatistics = alarmMonthlyStatisticsDate;
    },

    //故障案例分析饼图
    initAlarmConfirmedStatisticsChart(data){
      var alarmConfirmedStatisticsRef = this.$refs.alarmConfirmedStatistics;
      var alarmConfirmedStatistics = echarts.init(alarmConfirmedStatisticsRef);
      var alarmConfirmedStatisticsOption = {
        legend: {},
        tooltip: {},
        grid: {  
				  left: '0%',  
				  right: '0%', 
				  top: '30%',   
				  bottom: '0%', 
				  containLabel: true 
				},

        title: {
          text: '故障案例统计',
          //left: 'center'
          left: '6%',
          top: '12%',
          textStyle: {
              fontSize: 13,
              color: '#fff'
          }
        },
        xAxis: { 
          type: 'category', 
          data: ['大机组', '重点设备'],
          axisLabel: {
            show: true,
            fontSize: 12,
            //margin: 10, 
            color: '#DDDDDD'
          },},
        yAxis: {
            show: true,
            // name:"",
            // nameTextStyle: {  
            //     // color: '#fFFFFF',
            //     // padding: [0, 0, 0, 120],
            //     // fontSize: 15,
			      // },
            // position: 'left',
            type: 'value',
            axisLine: {
                show: true,
            },
            axisTick: {  
                show: true,
            },
            axisLabel: { 
                color: '#DDDDDD',
            },
            splitArea: {
                show: true,
                areaStyle: {
                    shadowBlur: 0,
                    shadowOffsetX:0,
                    shadowOffsetY:0,
                    opacity:0
                }
            },
            splitLine: {
                show:true, 
                lineStyle: {
                    type: "dotted",
                    width: 1,
                    color: 'rgba(100, 100, 100, 0.5)', 
                    dashOffset: 10 ,
                }
            }
        },
        series: [ 
          {
            data: [data.largeUnit, data.keyEquipment],
            type: 'bar',
            itemStyle: {
              color: 'rgba(143,112,32, 0.6)' 
            },
            barWidth: '20%' 
          }
        ]
      };
      
      alarmConfirmedStatistics.setOption(alarmConfirmedStatisticsOption);
      this.myCharts.alarmConfirmedStatistics = alarmConfirmedStatistics;
    },

    //设备状态统计
    initDeviceNumberStatisticsChart(data){
      if(this.userName=='nmyh'){
        data.health += data.fault
        data.fault=0
      }
      var deviceNumberStatisticsRef = this.$refs.deviceNumberStatistics;
      var deviceNumberStatistics = echarts.init(deviceNumberStatisticsRef);
      var deviceNumberStatisticsOption = {
        legend: {
          left: '10%' ,
          bottom:'2%',
          itemWidth: 10, 
          itemHeight: 10, 
          // 设置图例文字样式
          textStyle: {
              fontSize: 10, // 调整图例文字大小
              color: '#fff' 
          },
        },
        tooltip: {
          trigger: 'item'
        },
        // grid: {  
				//   left: '0%',  
				//   right: '0%', 
				//   top: '30%',   
				//   bottom: '0%', 
				//   containLabel: true 
				// },
        title: {
         text: '设备状态统计',
          //left: 'center'
          left: '6%',
          top: '12%',
          textStyle: {
              fontSize: 13,
              color: '#fff'
          }
        },
        series: [
              {
          // name: 'aaaa',
            type: 'pie',
            radius: '35%',
            data: [
              { value: data.offline, name: '离线', itemStyle: { color: "rgba(128, 128, 128, 0.9)" }},
              { value: data.health, name: '健康', itemStyle: { color: "rgba(0, 204, 102, 0.9)" } },
              { value: data.stopped, name: '停机', itemStyle: { color: "rgba(30, 144, 255, 0.9)"} },
              { value: data.fault, name: '故障', itemStyle: { color: "rgba(255, 0, 0, 0.9)" } },
            ],
            center: ['50%', '60%'], 
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              show: true, // 是否显示标签
              position: 'outside', // 标签的位置
              formatter: '{b}', // 标签的内容
              fontSize: 13, // 标签的字体大小
              color: '#fff', // 标签的颜色
              lineHeight: 18, // 标签的行高
              rich: {
              }
            }
          }
        ]
      };
      
      deviceNumberStatistics.setOption(deviceNumberStatisticsOption);
      this.myCharts.deviceNumberStatistics = deviceNumberStatistics;
    },

    //各级告警统计
    initAlarmMethodStatisticsChart(data){
      var alarmMethodStatisticsRef = this.$refs.alarmMethodStatistics;
      var alarmMethodStatistics = echarts.init(alarmMethodStatisticsRef);
      var alarmMethodStatisticsOption = {
        legend: {},
        tooltip: {},
        grid: {  
				  left: '0%',  
				  right: '0%', 
				  top: '30%',   
				  bottom: '0%', 
				  containLabel: true 
				},

        title: {
          text: '各级告警统计',
          //left: 'center'
          left: '6%',
          top: '12%',
          textStyle: {
              fontSize: 13,
              color: '#fff'
          }
        },
        xAxis: { 
          type: 'category', 
          data: ['智能','固高','固高高','预警'],
          // data: ['智能','高报','高高报','预警'],
          axisLabel: {
            show: true,
            fontSize: 11,
            //margin: 10, 
            color: '#DDDDDD'
          },},
        yAxis: {
            show: true,
            type: 'value',
            axisLine: {
                show: true,
            },
            axisTick: {  
                show: true,
            },
            axisLabel: { 
                color: '#DDDDDD',
            },
            splitArea: {
                show: true,
                areaStyle: {
                    shadowBlur: 0,
                    shadowOffsetX:0,
                    shadowOffsetY:0,
                    opacity:0
                }
            },
            splitLine: {
                show:true, 
                lineStyle: {
                    type: "dotted",
                    width: 1,
                    color: 'rgba(100, 100, 100, 0.8)', 
                    dashOffset: 10 ,
                }
            }
        },
        series: [
          {
            data: [data.intelligentAlarm, data.fixedHighReport,data.fixedHighHighReport,data.faultWarning],
            type: 'bar',
            itemStyle: {
              color: 'rgba(143,112,32, 0.6)'  
            },
            barWidth: '40%' 
          }
        ]
      };
      
      alarmMethodStatistics.setOption(alarmMethodStatisticsOption);
      this.myCharts.alarmMethodStatistics = alarmMethodStatistics;
    },

    //告警类型统计
    initAlarmTypeStatisticsChart(data){
      var alarmTypeStatisticsRef = this.$refs.alarmTypeStatistics;
      var alarmTypeStatistics = echarts.init(alarmTypeStatisticsRef);
      var alarmTypeStatisticsOption = {
        legend: {},
        tooltip: {},
        grid: {  
				  left: '0%',  
				  right: '0%', 
				  top: '30%',   
				  bottom: '0%', 
				  containLabel: true 
				},

        title: {
          text: '告警类型统计',
          //left: 'center'
          left: '6%',
          top: '12%',
          textStyle: {
              fontSize: 13,
              color: '#fff'
          }
        },
        xAxis: { 
          type: 'category', 
          data: ['振动','电流','温度'],
          axisLabel: {
            show: true,
            fontSize: 11,
            //margin: 10, 
            color: '#DDDDDD'
          },},
        yAxis: {
            show: true,
            type: 'value',
            axisLine: {
                show: true,
            },
            axisTick: {  
                show: true,
            },
            axisLabel: { 
                color: '#DDDDDD',
            },
            splitArea: {
                show: true,
                areaStyle: {
                    shadowBlur: 0,
                    shadowOffsetX:0,
                    shadowOffsetY:0,
                    opacity:0
                }
            },
            splitLine: {
                show:true, 
                lineStyle: {
                    type: "dotted",
                    width: 1,
                    color: 'rgba(100, 100, 100, 0.8)', 
                    dashOffset: 10 ,
                }
            }
        },
        series: [
          {
            data: [data.vibrate, data.current,data.temperature],
            type: 'bar',
            itemStyle: {
              color: 'rgba(143,112,32, 0.6)' 
            },
            barWidth: '30%' 
          }
        ]
      };
      
      alarmTypeStatistics.setOption(alarmTypeStatisticsOption);
      this.myCharts.alarmTypeStatistics = alarmTypeStatistics;
    },  

    //测点状态统计
    initSensorsStatusStatisticsChart(data){
      var sensorsStatusStatisticsRef = this.$refs.sensorsStatusStatistics;
      var sensorsStatusStatistics = echarts.init(sensorsStatusStatisticsRef);
      var sensorsStatusStatisticsOption = {
        legend: {
          // orient: 'vertical',
          left: '10%' ,
          bottom:'2%',
          itemWidth: 10, 
          itemHeight: 10, 
          // 设置图例文字样式
          textStyle: {
              fontSize: 10, // 调整图例文字大小
              color: '#fff' 
          },
        },
        tooltip: {
          trigger: 'item'
        },
        
        title: {
         text: '测点状态统计',
          //left: 'center'
          left: '6%',
          top: '12%',
          textStyle: {
              fontSize: 13,
              color: '#fff'
          }
        },
        series: [
              {
          // name: 'aaaa',
            type: 'pie',
            radius: '35%',
            data: [
              { value: data.offline, name: '离线', itemStyle: { color: "rgba(128, 128, 128, 0.9)" }},
              { value: data.health, name: '健康', itemStyle: { color: "rgba(0, 204, 102, 0.9)" } },
              { value: data.stopped, name: '停机', itemStyle: { color: "rgba(30, 144, 255, 0.9)"} },
              { value: data.fault, name: '故障', itemStyle: { color: "rgba(255, 0, 0, 0.9)" } },
            ],
            center: ['50%', '60%'], 
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              show: true, // 是否显示标签
              position: 'outside', // 标签的位置
              formatter: '{b}', // 标签的内容
              fontSize: 13, // 标签的字体大小
              color: '#fff', // 标签的颜色
              lineHeight: 18, // 标签的行高
              rich: {
              }
            }
          }
        ]
      };
      
      sensorsStatusStatistics.setOption(sensorsStatusStatisticsOption);
      this.myCharts.sensorsStatusStatistics = sensorsStatusStatistics;
    },    
    // webscoket 连接
    // creatWebSocket(){
    //   if(this.ws_manage.url == ''){
    //     apiWebsocketService().then(res => {
    //         if(res.data.code ==200) {
    //           this.ws_manage.url = res.data.data.url
    //           console.log(this.ws_manage.url)
    //           this.connectWebSocket();
    //         }else{
    //           this.$message.warning(`[${new Date().toLocaleString()}] 获取websocket URL失败,5s后重新获取`)
    //           setTimeout(() => {    
    //               this.creatWebSocket();    
    //           }, 5000);
    //         }
    //     }) .catch(res => {  
    //         this.$message.warning(`[${new Date().toLocaleString()}] 获取websocket URL失败,5s后重新获取`)
    //         setTimeout(() => {    
    //               this.creatWebSocket();    
    //         }, 5000);
    //     }); 
    //   } 
    // },
    // connectWebSocket() {    
    //     if(this.ws_manage.webcloseflag){
    //         this.disconnectWebSocket();
    //         return;
    //     }
    //     console.log(`[${new Date().toLocaleString()}] WebSocket 连接中...`)  
    //     if(this.ws_manage.isConnected == false && this.ws_manage.url != ''){
    //         this.ws_manage.socket = new WebSocket(this.ws_manage.url);
    //         this.ws_manage.socket.onopen = () => {
    //             console.log(`[${new Date().toLocaleString()}] WebSocket 连接已建立`);
    //             this.UpdateBigScreenData();
    //             this.ws_manage.isConnected = true;
    //             this.ws_manage.pingTimer = setInterval(() => {  
    //                 if (this.ws_manage.isConnected) {  
    //                     if(this.ws_manage.checktime >= 2){
    //                       console.log(`[${new Date().toLocaleString()}] ping超时`)
    //                        this.disconnectWebSocket();
    //                       // this.reconnectWebSocket();
    //                     }else{
    //                       this.ws_manage.checktime++;
    //                     }
    //                     // 发送PING消息  
    //                     if(this.ws_manage.socket){
    //                       const pingMessage = JSON.stringify({ type: 'ping' });
    //                       this.ws_manage.socket.send(pingMessage);
    //                       console.log(`[${new Date().toLocaleString()}] 发送PING消息`); 
    //                     }
    //                 }  
    //             }, 10000); // 10秒发送一次PING 

    //         };
    //         this.ws_manage.socket.onmessage = (event) => {
    //             this.ws_manage.receivedMessage = event.data
    //             console.log(`[${new Date().toLocaleString()}] 接收到消息:`, this.ws_manage.receivedMessage);
    //             try {  
    //               const data = JSON.parse(event.data); 
    //               if (data.type === 'alarm_occurred') {  
    //                 this.UpdateBigScreenData();
    //               } else if(data.type === 'device_status_changed') {
    //                 this.UpdateBigScreenData();
    //               } else if(data.type === 'pong'){
    //                   this.ws_manage.checktime = 0;
    //               }else if(data.type === 'sensor_status_changed') {

    //               }
    //             } catch (error) {  
    //               console.error('Error parsing WebSocket message:', error);  
    //             } 
    //         };
    //         this.ws_manage.socket.onclose = (event) => {
    //             console.log(`[${new Date().toLocaleString()}] WebSocket 连接已关闭`);
                
    //             if(this.ws_manage.webcloseflag){
    //                 this.disconnectWebSocket()
    //                 return;
    //             }
              
    //             this.clearPingTimer();
    //             ElMessage.error("网络异常请检查网络！");
    //             this.reconnectWebSocket();
    //         };
    //         this.ws_manage.socket.onerror = (error) => {
    //             console.log(`[${new Date().toLocaleString()}] WebSocket 错误:`, error);
    //             if(this.ws_manage.webcloseflag){
    //                 this.disconnectWebSocket()
    //                 return;
    //             }
    //         };
    //     }
    // },
    // disconnectWebSocket() {
    //     this.clearPingTimer();
    //     if(this.ws_manage.socket){
    //         if(this.ws_manage.isConnected){
    //           this.ws_manage.socket.close();
    //         }
    //         this.ws_manage.socket = null;
    //     }    
    //     this.ws_manage.isConnected = false;
    // },
    // reconnectWebSocket(){
    //     console.log(`[${new Date().toLocaleString()}] WebSocket 5秒后重连`)
    //     this.disconnectWebSocket();
    //     setTimeout(() => {    
    //         this.connectWebSocket();    
    //     }, 5000);       
    // },
    // clearPingTimer(){
    //     if (this.ws_manage.pingTimer) {  
    //         clearInterval(this.ws_manage.pingTimer);  
    //         this.ws_manage.pingTimer = null;  
    //         this.ws_manage.checktime = 0;
    //     }
    // },
    // TimerEvent() {
    //     this.UpdateBigScreenData();
    // },
    UpdateBigScreenData() {
      //折线图初始化
      this.getDeviceNumberStatistics();
      this.getAlarmMonthlyStatistics();
      this.getAlarmConfirmedStatistics();
      this.getAlarmTypeStatistics();
      this.getAlarmMethodStatistics();
      this.getSensorsStatusStatistics();

      
        if( this.userName != 'nmyh'){
        
         this.getAlarmsData();
      }
      this.getAllALarmData();

    },

    itemDataTransfer(val){
        var item = val;
        if(val.processed === true) {
          item.transform_type = this.getAlarmInfoText(val.processed_type); 
        } else {
          item.transform_type = this.getAlarmInfoText(val.type); 
        }
        //保留，详情中显示    
        switch(val.level){
            case 0:  item.transform_level="健康" ;break;
            case 1:  item.transform_level="预警" ;break;
            case 2:  item.transform_level="轻微" ;break;
            case 3:  item.transform_level="普通" ;break;
            case 4:  item.transform_level="高危" ;break;
            default: item.transform_level="未定义" ;break;
        }

        switch(val.method){
            case 1:  item.transform_method="智能报警";break;
            case 2:  item.transform_method="固定高报";break;
            case 3:  item.transform_method="固定高高报";break;
            case 4:  item.transform_method="故障预警";break;
            default: item.transform_method="未定义" ;break;
        }

        return item
    },

    getAllALarmData(){
      var parm = {
          ordering:"processed,-time",  
          state :0  
      };

      apiDevice().then(res=>{
          if(res.data.code ==200) {
              this.branchFactory = [[],[],[],[],[],[]];
              for(let i =0;i<res.data.data.total;i++){
                  let index =  this.factoryName.indexOf(res.data.data.items[i].branch_factory)
                  if(index != -1)
                    this.branchFactory[index].push(res.data.data.items[i].name)
              }
          
              apiAlarmslist(parm).then(res => {
                
                  if(res.data.code === 200) {
                    var items = res.data.data.items;

                    this.allDeviceAlarmInfo = { 
                      device: [] ,
                      alarm : [] 
                    };

                    for(var i=0;i<items.length;i++){
                      var deviceInex = this.allDeviceAlarmInfo.device.indexOf(items[i].device_name); 
                      if(deviceInex == -1){
                        this.allDeviceAlarmInfo.device.push(items[i].device_name);
                        var newDeviceIndex = this.allDeviceAlarmInfo.device.indexOf(items[i].device_name);
                        if(newDeviceIndex != -1){
                          if(newDeviceIndex >= this.allDeviceAlarmInfo.alarm.length){
                            this.allDeviceAlarmInfo.alarm.push([]);
                          }
                          var item = this.itemDataTransfer(items[i])
                          this.allDeviceAlarmInfo.alarm[newDeviceIndex].push(item);
                        }
                      }else{
                        var item = this.itemDataTransfer(items[i])
                        this.allDeviceAlarmInfo.alarm[deviceInex].push(item);
                      }             
                    }

                    //更新打点数据
                    this.updateMapAlarmCoordinates(true);
                  }else{
                      this.$message.error(res.data.msg)
                      this.updateMapAlarmCoordinates(false);
                  }
                }
              ).catch(error => {  
                  // this.$message.warning(`获取故障列表失败`); 
                  this.updateMapAlarmCoordinates(false);
              }); 


            }
          }) .catch(error => {  
              this.$message.warning(`获取设备列表失败`); 
          });
    },


    getDeviceOfFactory(device){
      for(var i=0;i<this.branchFactory.length;i++){
        var index = this.branchFactory[i].indexOf(device);
        if(index != -1)
          return i;
      }
      return -1;
    },

    getDeviceOfPlantName(device,plant_name){
      var index_fac = this.getDeviceOfFactory(device)
      if(index_fac == -1)
        return -1;
      for(var i=0;i<this.factoryFloorCoordinatesInfo[index_fac].length;i++){
        for(var j=0;j<this.factoryFloorCoordinatesInfo[index_fac][i].name.length;j++){
          if(plant_name == this.factoryFloorCoordinatesInfo[index_fac][i].name[j]){
            return i;
          }
        }
      }
      return this.factoryFloorCoordinatesInfo[index_fac].length -1; //“未知厂房”的坐标
    },


    updateMapAlarmCoordinates(flag){
      if(flag == false){
        this.alarmPoint = [];
        this.mutitabsstore.setAlarmPoint(this.alarmPoint);
        return
      }
      //删除已经消失的故障点位
      for(var i=0;i<this.alarmPoint.length;i++){
         var index = -1;
         for(var j=0;j<this.allDeviceAlarmInfo.device.length;j++){
            if(this.allDeviceAlarmInfo.device[j] == this.alarmPoint[i].device_name){
              index = j;
              break;
            } 
         }
         if(index == -1){
          this.alarmPoint.splice(i,1);
          i-=1;
         }
      }
      //按分厂分析出当前所有故障坐标
      this.alarmPointRegion[0] = [];
      this.alarmPointRegion[1] = [];
      this.alarmPointRegion[2] = [];
      this.alarmPointRegion[3] = [];
      this.alarmPointRegion[4] = [];
      this.alarmPointRegion[5] = [];
      for(var i=0;i<6;i++){
        for(var j=0;j<this.factoryFloorCoordinatesInfo[i].length;j++){
          this.alarmPointRegion[i].push([]);
        }
      }
      for(var i=0;i<this.alarmPoint.length;i++){
        var index = this.getDeviceOfFactory(this.alarmPoint[i].device_name);
        if(index == -1){
          continue;
        } 
        var index_plantName = this.getDeviceOfPlantName(this.alarmPoint[i].device_name, this.alarmPoint[i].item.plant_name)
        if(index == -1){
          continue;
        } 
        // NaN%
        this.alarmPointRegion[index][index_plantName].push({x:this.alarmPoint[i].x, y:this.alarmPoint[i].y});
      }

      //更新故障信息
      for(var i = 0; i < this.allDeviceAlarmInfo.device.length;i++){
          var index = -1;
          var device_name = this.allDeviceAlarmInfo.device[i];
          var plant_name = this.allDeviceAlarmInfo.alarm[i][0].plant_name;
          for(var j=0;j<this.alarmPoint.length;j++){
            if(this.alarmPoint[j].device_name == device_name){
              index = j;
              break;
            }
          }

          if(index == -1){//新故障点
            var index_1 = this.getDeviceOfFactory(device_name);
            if(index_1 == -1){
              continue;
            }
            var index_plantName = this.getDeviceOfPlantName(device_name, plant_name)
              
            var coordinates = this.creatCoordinatesRecursion(this.factoryFloorCoordinatesInfo[index_1][index_plantName],this.alarmPointRegion[index_1][index_plantName],2);
            var alarm_info = "";
            for(var n=0;n<this.allDeviceAlarmInfo.alarm[i].length;n++){
              if(this.allDeviceAlarmInfo.alarm[i][n].type == 901){
                alarm_info +=`${this.getAlarmInfoText(this.allDeviceAlarmInfo.alarm[i][n].type)}:${this.allDeviceAlarmInfo.alarm[i][n].sensor_name}:${(this.allDeviceAlarmInfo.alarm[i][n].intensity).toFixed(2)}A`;
                
              }
              else if(this.allDeviceAlarmInfo.alarm[i][n].type == 1001){
                alarm_info +=`${this.getAlarmInfoText(this.allDeviceAlarmInfo.alarm[i][n].type)}:${this.allDeviceAlarmInfo.alarm[i][n].sensor_name}:${(this.allDeviceAlarmInfo.alarm[i][n].intensity).toFixed(2)}°C`;
               }
              else{
                alarm_info +=`${this.getAlarmInfoText(this.allDeviceAlarmInfo.alarm[i][n].type)}:${this.allDeviceAlarmInfo.alarm[i][n].sensor_name}:${(this.allDeviceAlarmInfo.alarm[i][n].intensity).toFixed(2)}mm/s,${this.allDeviceAlarmInfo.alarm[i][n].temperature}°C`;
               
              }
              alarm_info += "\n";
            }
            var point = {
              x:coordinates.x + "%",
              y:coordinates.y + "%",
              factory:this.factoryName[index_1],
              plant_name:plant_name,
              device_name:device_name,
              alarm_info:alarm_info,
              item: this.allDeviceAlarmInfo.alarm[i][0]
            }
           
            this.alarmPoint.push(point)
          }else{ //旧故障点
            var alarm_info = "";
            for(var n=0;n<this.allDeviceAlarmInfo.alarm[i].length;n++){
              if(this.allDeviceAlarmInfo.alarm[i][n].type == 901){
                alarm_info +=`${this.getAlarmInfoText(this.allDeviceAlarmInfo.alarm[i][n].type)}:${this.allDeviceAlarmInfo.alarm[i][n].sensor_name}:${(this.allDeviceAlarmInfo.alarm[i][n].intensity).toFixed(2)}A`;
                
              }
              else if(this.allDeviceAlarmInfo.alarm[i][n].type == 1001){
                alarm_info +=`${this.getAlarmInfoText(this.allDeviceAlarmInfo.alarm[i][n].type)}:${this.allDeviceAlarmInfo.alarm[i][n].sensor_name}:${(this.allDeviceAlarmInfo.alarm[i][n].intensity).toFixed(2)}°C`;
               }
              else{
                alarm_info +=`${this.getAlarmInfoText(this.allDeviceAlarmInfo.alarm[i][n].type)}:${this.allDeviceAlarmInfo.alarm[i][n].sensor_name}:${(this.allDeviceAlarmInfo.alarm[i][n].intensity).toFixed(2)}mm/s,${this.allDeviceAlarmInfo.alarm[i][n].temperature}°C`;
               
              }
              alarm_info += "\n";
            }
            this.alarmPoint[index].alarm_info = alarm_info;
            this.alarmPoint[index].item = this.allDeviceAlarmInfo.alarm[i][0];
          }
         
      }
    
      this.mutitabsstore.setAlarmPoint(this.alarmPoint);

    },

    getAlarmInfoText(alarm) {
        switch (alarm) {
          case 0: return '空';
          case 1: return '停机';
          case 99: return '其他故障';
          case 100: return '模拟事件';
          case 101: return '转子不对中';
          case 102: return '转子不平衡';
          case 103: return '轴弯曲';
          case 104: return '轴裂纹';
          case 105: return '轴承松动';
          case 106: return '滚动轴承故障';
          case 107: return '滑动轴承故障';
          case 201: return 'UPS温度过高';
          case 202: return 'UPS电源局部放电';
          case 203: return 'UPS电源机械性故障';
          case 301: return '空调压缩机故障';
          case 401: return '变压器局部放电';
          case 402: return '变压器绕组形变';
          case 403: return '变压器部件松动';
          case 404: return '变压器直流偏磁';
          case 901: return '电流异常';
          case 1001:return '温度异常';
          default: return '未知状态';
        }
    },

    //函数递归生成坐标  参数:生成坐标的工厂下厂房的区域，该区域已生成的坐标，初始要求的坐标间距（百分比单位） 
    creatCoordinatesRecursion(factroryRegion,point,interval){

      var x0 = factroryRegion.x0 / this.factoryOriginMapWidth * 100
      var x1 = factroryRegion.x1 / this.factoryOriginMapWidth * 100
      var y0 = factroryRegion.y0 / this.factoryOriginMapHeight * 100
      var y1 = factroryRegion.y1 / this.factoryOriginMapHeight * 100

      if(interval <= 0 || point.length == 0){ 
        var x = this.generateRandomNumber(x0 , x1 );
        var y = this.generateRandomNumber(y0 , y1 )-5;
        return { x, y};
      }

      //生成的坐标间距10次未成功生成就降低间距继续迭代生成 interval-0.5 
      for(var i = 0 ; i< 10; i++){
        var x = this.generateRandomNumber(x0 ,x1);
        var y = this.generateRandomNumber(y0 ,y1)-5;
        var num =0;
        for(var j=0;j<point.length;j++){
          if(Math.abs(point[j].x - x) >= interval && Math.abs(point[j].y - y) >= interval){
            num++;
          }
        }
        if(num == point.length){
          return { x, y};
        }
      }

      return this.creatCoordinatesRecursion(factroryRegion,point,interval-0.5);
    },

    generateRandomNumber(min, max) {
      let randomNumber = Math.random() * (max - min) + min;
      return Math.round(randomNumber / 0.1) * 0.1; //坐标分辨率0.1
      
    },

    getAlarmsData(){
      apiAlarmslist(this.AlarmsParm).then(res => {
        if(res.data.code === 200) {
          this.tableData = res.data.data.items;
          this.initTable(); // 初始化表格
        }else{
            this.$message.error(res.data.msg)
        }
      }) 
    },

    initTable() {
      var tableElement = document.querySelector('.custom-table');
      if (tableElement) {
        // 如果表格元素已经存在，则先清空它的内容
        console.log("table is alive");
        tableElement.innerHTML = '';
      } else {
        // 否则，创建新的表格元素
        console.log("table is not alive");
        tableElement = document.createElement('table');
        tableElement.className = 'custom-table';
      }
      // 创建表头  
      var thead = tableElement.createTHead();  
      var theadRow = thead.insertRow(0);  

      // 为表头添加单元格  
      theadRow.insertCell(0).innerText = '类型'; // 假设你要显示的表头文本  
      theadRow.insertCell(1).innerText = '报警类型';  
      theadRow.insertCell(2).innerText = '设备名称';  
      theadRow.insertCell(3).innerText = '告警等级';  
      theadRow.insertCell(4).innerText = '时间';  
      theadRow.insertCell(5).innerText = '处理状态';  
      theadRow.insertCell(6).innerText = '详情';  
      
      // 添加表格内容
      var tbody = tableElement.createTBody();
      var data = this.tableData.slice(0, 4);  // 获取前5行数据

      data.forEach((row, rowIndex) => {
        var row_temp = row;
        var tableRow = tbody.insertRow(rowIndex);
        
        switch(row.method){
            case 1:  row.transform_method="智能报警";break;
            case 2:  row.transform_method="固定高报";break;
            case 3:  row.transform_method="固定高高报";break;
            case 4:  row.transform_method="故障预警";break;
            default: row.transform_method="未定义" ;break;
        }

        // 第一列：type
        var typeCell = tableRow.insertCell(0);
        if(row.processed === true) {
          row_temp.transform_type = this.getAlarmInfoText(row.processed_type) || ''; 
        } else {
          row_temp.transform_type = this.getAlarmInfoText(row.type) || ''; 
        }
        //row_temp.transform_type = typeMap[row.type] || ''; 
        typeCell.innerText = row_temp.transform_type;
        //tableRow.
        // 第二列：alarm_type
        var deviceTypeCell = tableRow.insertCell(1);
        row_temp.transform_alarm_type  = 
        row.type === 901 ? "电流" :
        row.type === 1001 ? "温度" : "振动";
        deviceTypeCell.innerText = row_temp.transform_alarm_type;
        // 第三列：device_name
        var deviceNameCell = tableRow.insertCell(2);
        deviceNameCell.innerText = row.device_name;
        // 第四列：level
        var levelCell = tableRow.insertCell(3);
        row_temp.transform_level = 
        row.level === 0 ? "健康" : 
        row.level === 1 ? "预警" : 
        row.level === 2 ? "轻微" : 
        row.level === 3 ? "普通" : 
        row.level === 4 ? "高危" : 
        row.level;
        levelCell.innerText = row_temp.transform_level;
        // 第五列：time
        var timeCell = tableRow.insertCell(4);
        var timeParts = row.time.split("+");  
        var timeBeforePlus = timeParts[0]; // "2026-02-07 04:00:00"  
  
        timeCell.innerText = timeBeforePlus;
        // 第六列：processed_type
        var processedTypeCell = tableRow.insertCell(5);
        row_temp.transform_state =
        row.processed === true ? "已处理" : 
        row.processed === false ? "未处理" :
        row.processed;
        processedTypeCell.innerText = row_temp.transform_state;
        // 第七列："查看详情"
        var viewDetailsCell = tableRow.insertCell(6);
        var detailsLink = document.createElement('a');
        detailsLink.setAttribute('href', 'javascript:void(0)');
        detailsLink.innerText = '查看详情';
        detailsLink.style.color = 'deepskyblue';
        detailsLink.addEventListener('click', () => {
          this.navigateToAlarmsManage(row_temp); // 传递相应的行数据作为参数
        });
        viewDetailsCell.appendChild(detailsLink);
      });
      // 将表格添加到页面中
      var rtTableElement = this.$refs.rt_table;
      rtTableElement.appendChild(tableElement);
    },

    generateOption(datas, titleText) {
      var option = {
        backgroundColor: '#111539',
        color: ["#00CC66", "#FF0000", "#0000FF", "#808080"],
        title: {
          text: titleText,
          textStyle: {
            color: '#fff',
            fontWeight: 'bold',
            fontSize: 18
          },
          left: '39%',
          top: '44%',
          textAlign: 'center'
        },
        legend: {
          itemHeight: 14,
          itemWidth: 14,
          icon: "rect",
          orient: "vertical",
          top: "center",
          right: "5%",
          textStyle: {
            align: "center",
            color: "#fff",
            verticalAlign: "middle",
            rich: {
              name: {
                width: 80,
                fontSize: 16,
              },
              value: {
                width: 20,
                align: "right",
                fontFamily: "Medium",
                fontSize: 16,
              },
              rate: {
                width: 10,
                align: "right",
                fontSize: 16,
              },
            },
          },
          data: datas.map(item => item.name),
          formatter: (name) => {
            if (datas.length) {
              const item = datas.filter((item) => item.name === name)[0];
              return `{name|${name}}`;
            }
          },
          selectedMode: false, // 禁用右侧点击事件
        },
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            return params.name + ':' + params.value + ' (' + Math.round(params.percent) + '%)';
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["40%", "50%"],
            roseType: "radius",
            label: {
              formatter: function(params) {
                return Math.round(params.percent) + '%';
              },
            },
            labelLine: {
              length: 1,
              length2: 20,
            },
            data: datas,
          },
        ],
      };
      return option;
    },
    transformData(data) {
      return data.map((item) => {
        let name, value, itemStyle;
        switch (item.status) {
          case 1:
            name = "健康";
            itemStyle = { color: "rgba(0, 204, 102, 0.9)" }; // 健康状态的颜色
            break;
          case 2:
            name = "故障";
            itemStyle = { color: "rgba(255, 0, 0, 0.9)" }; // 故障状态的颜色
            break;
          case 3:
            name = "停机";
            itemStyle = { color: "rgba(30, 144, 255, 0.9)" }; // 停机状态的颜色
            break;
          case 4:
            name = "离线";
            itemStyle = { color: "rgba(128, 128, 128, 0.9)" }; // 离线状态的颜色
            break;
          default:
            name = "未知状态";
            itemStyle = { color: "rgba(0, 0, 0, 0.8)" }; // 未知状态的颜色
        }
        value = item.count;
        return { name, value, itemStyle };
      });
    },

    navigateToDevicesManage(event) {  
      // 在这里进行页面导航，将用户导向 alarmsManage.vue 页面，并可以传递参数等。  
      // alarmsManage.vue 用 this.$route.query.pointData 访问参数 
      this.$router.push({ name: 'deviceManage', query: {status:event} }); // 假设路由名称为 'alarmsManage'  
    },  

    faultInfoFn(row){
        let title = "故障告警/告警详情：" + row.device_name
        this.$refs.faultInfoFlag.faultInfoFn(row,title)
    },

    handleInfo(flag){
      this.UpdateBigScreenData(); 
        // if(flag == 'comfirm'){
        //     //this.$refs.faultHandleFlag.faultHandleFn(this.tableLineData,"告警处理")
        // }
        // this.tableLineData = {}
    },
    
    fnupdataConfirm(flag){
        //待确认
    },
    navigateToAlarmsManage(rowData,device_name) {  
     
      
      if(rowData.device_name == device_name || device_name == null ){
        this.tableLineData = rowData;
        this.faultInfoFn(rowData);
      }
      //this.$router.push({ name: 'alarmsManage', query: { id: rowData.id } }); // 假设路由名称为 'alarmsManage'  
    },  
    navigateToDevicesHandle(dev) {  
      // 在这里进行页面导航，将用户导向 alarmsManage.vue 页面，并可以传递参数等。  
      // alarmsManage.vue 用 this.$route.query.pointData 访问参数 
      // let roleValue = this.mutitabsstore.getRole;
      let roleValue = getStorage("role")
      if(roleValue != null && (roleValue == 1 || roleValue == 0)){
        this.$router.push({ name: 'deviceManage', query: { type: dev } }); // 假设路由名称为 'alarmsManage' 
      }else{
        console.log("No jump permission")
      }
    },  
    initResize() {
      window.addEventListener('resize', this.handleResize.bind(this));
    },
    handleResize() {
      // 在这里处理 resize 事件
      if (this.myCharts.alarmMonthlyStatistics) {
        this.myCharts.alarmMonthlyStatistics.dispose();
      }
      if (this.myCharts.alarmConfirmedStatistics) {
        this.myCharts.alarmConfirmedStatistics.dispose();
      }
      if (this.myCharts.deviceNumberStatistics) {
        this.myCharts.deviceNumberStatistics.dispose();
      }             
      if (this.myCharts.alarmMethodStatistics) {
        this.myCharts.alarmMethodStatistics.dispose();
      }
      if (this.myCharts.alarmTypeStatistics) {
        this.myCharts.alarmTypeStatistics.dispose();
      }      
      if (this.myCharts.sensorsStatusStatistics) {
        this.myCharts.sensorsStatusStatistics.dispose();
      } 


      setTimeout(() => {
        this.initDeviceNumberStatisticsChart(this.deviceNumberStatistics);
        this.initAlarmMonthlyStatisticsChart(this.alarmMonthlyStatisticsDate);
        this.initAlarmConfirmedStatisticsChart(this.alarmConfirmedStatisticsDate);
        this.initAlarmMethodStatisticsChart(this.alarmMethodStatisticsData);
        this.initAlarmTypeStatisticsChart(this.alarmTypeStatisticsDate);
        this.initSensorsStatusStatisticsChart(this.sensorsStatusStatisticsData);

      }, 100); // 延迟 100 毫秒
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}
</script>

<style lang="scss"  >

.device_state {
  grid-column: 1 / span 34;
  grid-row: 1 / span 2;

  background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

  cursor: pointer;
}

.device_state_grid{
  display: grid;
  height: 100%;
  grid-template-columns: repeat(5, 1fr); /* 5 列 */
  grid-gap: 10px; /* 子 div 之间的间隙 */
  
}


.text-div-1 {
  display: flex;
  align-items: center;  
  justify-content: space-between; 
  
  background: url("../../assets/bigscreen/devman1.png") no-repeat;
  background-size: 27% 50%;
  background-position: 10% 30%;
  background-repeat: no-repeat; 
  // background-color: #d76060;
 
}
.home-status{
  margin-left:40%;
  display: flex;
  flex-direction: column;
}
.text-div-2 {
  display: flex;         
  align-items: center;  
  justify-content: space-between; 

  background: url("../../assets/bigscreen/devman2.png") no-repeat;
  background-size: 27% 50%;
  background-position: 10% 30%;
  background-repeat: no-repeat; 
}
.text-div-3 {
  display: flex;         
  align-items: center;  
  justify-content: space-between; 

  background: url("../../assets/bigscreen/devman3.png") no-repeat;
  background-size: 27% 50%;
  background-position: 10% 30%;
  background-repeat: no-repeat; 
}
.text-div-4 {
  display: flex;         
  align-items: center;  
  justify-content: space-between; 

  background: url("../../assets/bigscreen/devman4.png") no-repeat;
  background-size: 27% 50%;
  background-position: 10% 30%;
  background-repeat: no-repeat; 
}
.text-div-5 {
  display: flex;         
  align-items: center;  
  justify-content: space-between; 
  background: url("../../assets/bigscreen/devman5.png") no-repeat;
  background-size: 27% 50%;
  background-position: 10% 30%;
  background-repeat: no-repeat; 
}

// 报警趋势
.alarms-container {
  grid-column: 29 / span 8;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-color: #fff;
  background-repeat: no-repeat;
  background-color: transparent;
  // filter: opacity(50%);
  // width: 100%;
  // height: 100%;
}
// 故障案例统计
.fault-container {
  grid-column: 8 / span 3;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
}
// 中间地图
.bigpic-container{
  grid-column: 7 / span 18;
  grid-row: 3 / span 12 ;
  position: relative;
  // background-image: url('../../assets/bigscreen/block_bg.png');
  // background-size: 100% 100%;
  // background-repeat: no-repeat;
  // background-color: transparent;
}
// 中间地图
.bigpic-container-div{
  // background-image: url('../../assets/factory.jpg');
  // background-image: url('../../assets/factory1.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
  width: 100%;
  height: 100%;
}

//设备状态统计
.deviecstate-container{
  grid-column: 25  / span 4;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
  background-color: #fff;
  
}
// 各级告警统计
.statistics-container{
  grid-column: 22 / span 3;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
 
}
// 告警类型统计
.alarmstype-container{
  grid-column: 1 / span 3;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
}
// 告警列表
.alarmlist-container{
  grid-column: 11 / span 11;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
  // opacity: 0.7;
  font-size: 12px; /* 增大字体大小为20像素 */
  // height: 90%; /* 设置高度为100% */  
 
  overflow: auto; /* 添加 overflow 样式 */

}
@media (min-width: 3000) {
  .alarmlist-container{
    font-size: 24px;
  }
  
}
// 测点状态
.measurepoint-container{

  grid-column: 4 / span 4;
  grid-row: 15 / span 5 ;
  position: relative;
  background-image: url('../../assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;

}


.full-window-layout {
  display: grid;
  overflow: hidden;
  grid-template-columns: repeat(30, 1fr);
  grid-template-rows: repeat(18, minmax(0, 1fr));
  grid-gap: 10px;
  height: calc(100vh * 0.85);
 
 
}
.col {
  /*
  background-color: lightgray;
  border: 1px solid black;
  */
  padding: 3px;
  background-color: transparent;
  border: none;
}

.in_table {  
  position: relative;
  margin-top: 6%;
}

.table-title {
  position: relative;
  top: 12%; /* 距离父元素顶部的距离为 20 像素 */
  left: 7.5%; /* 距离父元素左侧的距离为 30 像素 */
  font-size: 13px; /* 调整字体大小 */
  font-weight: bold; /* 添加粗体样式 */
  color: #fff; /* 设置文本颜色为白色 */
}

.chart-container-title {
  position: relative;
  top: 6%; /* 距离父元素顶部的距离为 20 像素 */
  left: 7%; /* 距离父元素左侧的距离为 30 像素 */
  font-size: 20px; /* 调整字体大小 */
  font-weight: bold; /* 添加粗体样式 */
  color: #fff; /* 设置文本颜色为白色 */
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  // border: none; /* 设置表格边框透明 */
  text-align: center; /* 将表格内容居中显示 */
  // font-size: 10px; /* 设置字体大小 */
}
.custom-table th, .custom-table td {
  /*border: 1px solid transparent; /* 设置单元格边框透明 */
  padding: 2px; /* 调整单元格内边距 */
  /*background-color: transparent; /* 去除单元格背景色 */
  font-size: 14px; /* 设置字体大小 */
  line-height: 18px; /* 设置单元格行高为10像素 */
}
.custom-table th, .custom-table td {
  color: lightblue;
}
.custom-table th {
  font-weight: bold; /* 添加粗体样式 */
}


.rt_3dpie {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.rt_3dpieover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
}

.rt_trends {
  grid-column: 3 / span 2;
  grid-row: 3;
  background-image: url('@/assets/bigscreen/alarms.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
}

.rt_map {
  position: relative;
  width: 100%;
  height: 100%;
}

.rtmarker {

    position: fixed;
    // position: absolute;
  width: 30px;
  height: 30px;

 
  
 
}
.image-rtmarker{
  animation: markerAnimation 2s infinite alternate;
}
.import-Info{
  position: absolute;
  width:  100px;
 
  border-radius: 8px;
  background-color: rgba(	25, 25,112, 0.7);
  font-size: 12px;
  color: #fff;
  padding:4px;
  .Info1{
    display: block;
    margin-top: 6px;
  }
  
}


.rtmarker img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rtmarker:hover {  
  cursor: pointer; /* 或者使用其他链接样式，如 'link' */  
}

@keyframes markerAnimation {
  0% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(0) scale(1.15);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}
</style>
